import { render, staticRenderFns } from "./BlendOnIcon.vue?vue&type=template&id=8bd1c67e&"
import script from "./BlendOnIcon.vue?vue&type=script&lang=js&"
export * from "./BlendOnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports